import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function TextField(theme: Theme) {
  return {
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&.Mui-disabled': { opacity: 0.5, background: theme.palette.action.disabledBackground },
        },
      },
    },
  };
}
